import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface ICategoryTree {
  filterOptions: IFilterOptions;
  selectedCategories: string[];
  setSelectedCategories: (items: string[]) => void;
}

const CategoryTree = ({ filterOptions, selectedCategories, setSelectedCategories }: ICategoryTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatCategories =
    filterOptions?.categories.map((category) => ({
      id: category.id,
      name: category.label,
      type: "tag",
    })) || [];

  const filteredCategories = formatCategories.filter((category) =>
    get(category, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectCategory = ({ items }: SelectionChangeResponse) => setSelectedCategories(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredCategories}
      selectedItems={selectedCategories}
      onSelectionChange={handleSelectCategory}
      hasMultiselect={!isEmpty(filteredCategories)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-tag" value={filteredCategories.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em categoria" onChange={handleUpdateSearch} />}
    />
  );
};

export default CategoryTree;
